module.exports = __webpack_public_path__ + "img/shake_title.b865e171.png";